import { initializeTelemetry } from '@if/core/telemetry'
import { GlobalDesignSystemProvider, initializeAuth } from '@if/mui'
import { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import { fetchFeatureSwitches } from './api/config-api'
import { authConfig, mapClaims } from './auth'
import Router from './containers/Router'
import { SystemFlowProvider } from './providers/SystemFlowProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

initializeTelemetry({
  instrumentationKey: import.meta.env.VITE_APP_INSIGHT_INSTRUMENTAL_KEY,
  appName: 'Loan',
})

const bootstrap = async () => {
  const auth = await initializeAuth(authConfig)
  if (!auth) return // redirect in flight — render nothing

  createRoot(document.getElementById('root')!).render(
    <GlobalDesignSystemProvider
      auth={auth}
      mapClaims={mapClaims}
      queryClient={queryClient}
      fetchFeatureSwitches={fetchFeatureSwitches}
    >
      <SystemFlowProvider>
        <Router />
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
      </SystemFlowProvider>
    </GlobalDesignSystemProvider>,
  )
}

void bootstrap()
